import { action as apiAction } from 'api/Api'
import {
  increaseFileCount
} from '../redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  id: number
  url: string
  documentSourceId: number
}

export default (payload: Payload) => async dispatch => {
  const { id, url, documentSourceId } = payload

  const optimisticAction = optimisticDispatch(dispatch, increaseFileCount({
    id
  }))

  try {
    await apiAction('AddDocumentToCard', {
      cardId: id,
      documentsSourceId: documentSourceId,
      url,
      position: 0
    })
  } catch (error) {
    if (error.code !== 300) { // Duplicate
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}
